// extracted by css-extract-rspack-plugin
export default {"wrapper":"_bcd3f0e8","header":"_80b0a0e4"};